import { ChangeDetectorRef, ApplicationRef, Component, OnInit, ViewChild } from "@angular/core";
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import {
  AlertController,
  IonicModule,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  ToastController,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { DynamicFormComponent } from "../../components/dynamic-form/dynamic-form.component";
import { HomeCustomPage } from "../home-custom/home-custom.page";
import { FieldConfig } from "../../interfaces/field.interface";
import { RecuperarSenhaPage } from "../login/recuperar-senha/recuperar-senha.page";
import { CadastroProvider } from "src/app/services/cadastro/cadastro";
import { UserProvider } from "src/app/services/user/user";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { EventService } from "./events-abri-termo/event.service";
@Component({
  selector: "app-form-gerador",
  templateUrl: "./form-gerador.page.html",
  styleUrls: ["./form-gerador.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    DynamicFormComponent,
    TranslateModule,
    LoadingSpinnerComponent,
  ],
})
export class FormGeradorPage implements OnInit {
  @ViewChild(DynamicFormComponent) form: DynamicFormComponent[] = [];
  @ViewChild(DynamicFormComponent) dynamicForm!: DynamicFormComponent;
  campos: FieldConfig[] = [];
  idInstituicao;
  tipo;
  idPessoaTipo;
  idPessoa;
  titulo;
  hideBack;
  erro_email = false;
  erro_cpf = false;
  loaded = false;
  esconderFacebook = true;
  facebook: any = {};
  encrypt;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public cadastroProvider: CadastroProvider,
    public loadingController: LoadingController,
    private changeDetector: ChangeDetectorRef,
    private application: ApplicationRef,
    public toastCtrl: ToastController,
    public viewCtrl: NavController,
    private translate: TranslateService,
    public userProvider: UserProvider,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private eventService: EventService,
    public router: Router
  ) {
    this.idInstituicao = this.navParams.get("idInstituicao");
    this.tipo = this.navParams.get("form");
    this.idPessoaTipo = this.navParams.get("idPessoaTipo");
    this.idPessoa = this.navParams.get("idPessoa");
    this.titulo = this.navParams.get("titulo");
    this.facebook = this.navParams.get("facebook");
    this.hideBack = this.navParams.get("hideBack");
    this.encrypt = this.navParams.get("encrypt");
    this.esconderFacebook = this.navParams.get("hideFacebook");
    
    if (this.encrypt) {
      this.userProvider.getInstituicaoByToken(this.idInstituicao).subscribe((result) => {
        this.idInstituicao = result;
        this.criarFomulario();
      });
    } else {
      this.criarFomulario();
    }
  }

  ngOnInit() {}

  criarFomulario() {
    let idLogado = this.userProvider.loggedUser ? this.userProvider.loggedUser.id : 0;
    if (this.idInstituicao) {
      this.cadastroProvider
        .buscarCampos(this.idInstituicao, this.tipo, this.idPessoa, this.idPessoaTipo, idLogado)
        .subscribe((busca) => {
          //VALIDACAO DE REQUIRED, MAXSIZE E EMAIL
          busca.forEach(
            (result: {
              name: string;
              value: any;
              validations: {
                name: string;
                validator: ((control: AbstractControl<any, any>) => ValidationErrors | null) | ValidatorFn;
              }[];
              requirido: any;
              tamanho: number;
              inputType: string;
              type: string;
              options: any;
            }) => {
              if (this.facebook) {
                if (result.name == "nome") {
                  result.value = this.facebook.nome;
                } else if (result.name == "email") {
                  result.value = this.facebook.email;
                }
              }

              result.validations = [];
              if (result.requirido) {
                result.validations.push({
                  name: "required",
                  validator: Validators.required,
                });
              }

              if (result.tamanho) {
                result.validations.push({
                  name: "maxlength",
                  validator: Validators.maxLength(result.tamanho),
                });
              }

              if (result.inputType == "password") {
                result.validations.push({
                  name: "minlength",
                  validator: Validators.minLength(6),
                });
              }

              if (result.inputType == "email") {
                result.validations.push({
                  name: "email",
                  validator: Validators.email,
                });
              }

              if (result.type === "select") {
                if (
                  
                  result.options?.length > 0 &&
                  result.options[0].label === "-- Selecione --"
                ) {
                  result.options = result.options.slice(1);
                }
              }
            }
          );

          this.campos = busca;

          //ADD BOTAO DE SUBMIT
          this.campos.push({
            type: "button",
            label: "Save",
          });

          if (this.tipo == "APP_CAD_INICIO") {
            this.campos.push({
              type: "termo",
              idInstituicao: this.idInstituicao,
            });
          }

          this.loaded = true;

          // NÃO REMOVER ISSO, SÉRIO
          if (!this.application["destroyed"]) {
            this.changeDetector.detectChanges();
          }
        });
    }

    setTimeout(() => {
      if (this.form && this.form.length > 0) {
        this.form[0].createControlFromFields(this.campos);
      }

      this.loaded = true;
    }, 1000);
  }

  async submit(cadastro: any) {
    this.setEndereco(cadastro);
    this.setCadastroDetails(cadastro);

    if (this.tipo == "APP_CAD_INICIO") {
      this.cadastroInicio(cadastro);
    } else if (this.tipo == "APP_EXT_OVEL") {
      this.cadastroOvelhinhas(cadastro);
    } else {
      this.outrosCadastros(cadastro);
    }
  }

  private setEndereco(cadastro: any) {
    const endereco = this.campos.find((e) => e.type == "endereco");
    if (endereco) {
      cadastro.endereco = endereco.value;
    }
  }

  private setCadastroDetails(cadastro: any) {
    cadastro.idInstituicao = this.idInstituicao;
    cadastro.idPessoaTipo = this.idPessoaTipo;
    if (this.idPessoa) {
      cadastro.id = this.idPessoa;
    }
  }

  async esqueceuSenha() {
    this.modalCtrl.dismiss();
    let data = { modal: true };
    const modalPage = await this.modalCtrl.create({
      component: RecuperarSenhaPage,
      componentProps: data,
    });
    modalPage.present();
  }

  public async cadastroInicio(cadastro: any) {
    try {
      const data = await this.cadastroProvider.salvarCadastroInicial(cadastro, this.facebook).toPromise();
      if (!data.error) {
        await this.realizarLogin(data.login, cadastro.senha);
        await this.exibirToast(this.translate.instant("Cadastro realizado com sucesso"));

        if (this.hideBack) {
          await this.abrirModal(HomeCustomPage);
        } else {
          await this.route(data);
        }
      } else {
        await this.handleCadastroError(data);
      }
    } catch (error) {
      await this.exibirAlerta("Erro", "Ocorreu um erro ao processar o cadastro.");
    }
  }

  public async cadastroOvelhinhas(cadastro: any) {
    try {
      const data = await this.cadastroProvider.salvarCadastroInicial(cadastro, null).toPromise();
      if (!data.error) {
        await this.realizarLogin(data.login, cadastro.senha);
        await this.exibirToast(this.translate.instant("Cadastro realizado com sucesso"));
        await this.abrirModal(HomeCustomPage, { ovelinhas: true });
      } else {
        await this.handleCadastroError(data);
      }
    } catch (error) {
      await this.exibirAlerta("Erro", "Ocorreu um erro ao processar o cadastro.");
    }
  }

  public async outrosCadastros(cadastro: any) {
    cadastro.idPessoaAtual = this.userProvider.loggedUser.id;
    try {
      const data = await this.cadastroProvider.salvarCadastro(cadastro).toPromise();
      if (data.error) {
        await this.exibirToast(data.mensagem);
        return;
      }
      await this.modalCtrl.dismiss(data);
      await this.exibirToast(this.translate.instant("Cadastro realizado com sucesso"));
    } catch (error) {
      await this.exibirAlerta("Erro", "Ocorreu um erro ao processar o cadastro.");
    }
  }

  private async realizarLogin(usuario: string, senha: string) {
    await this.userProvider.login({ usuario, senha, instituicao: this.idInstituicao }).toPromise();
  }

  private async exibirToast(message: string) {
    const toast = await this.toastCtrl.create({ message, duration: 3000 });
    toast.present();
  }

  private async abrirModal(component: any, componentProps?: any) {
    const modal = await this.modalCtrl.create({ component, componentProps });
    modal.present();
  }

  private route(data: any) {
    this.modalCtrl.dismiss(data);
  }

  async handleCadastroError(apiReturn: any) {
    if (apiReturn.item == 'email') {
      const alert = await this.alertCtrl.create({
        subHeader: "Erro",
        message: apiReturn.mensagem,
        buttons: [
          {
            text: "Redefinir Senha",
            handler: () => {
              this.goToForgotPassword();
            },
          },
          {
            text: "OK",
            role: "cancel",
          },
        ],
      });
      await alert.present();

      this.dynamicForm?.finishSubmit();
      return;
    }

    this.exibirAlerta("Erro", this.translate.instant(apiReturn.mensagem));
  }

  private async exibirAlerta(subHeader: string, message: string) {
    const alert = await this.alertCtrl.create({
      subHeader,
      message,
      buttons: [
        {
          text: "OK",
          role: "cancel",
        },
      ],
    });
    await alert.present();
    this.dynamicForm?.finishSubmit();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  buscarDadosFacebook() {
    let permissions = new Array<string>();
    permissions = ["public_profile", "email"];

    // this.fb.login(permissions).then((response: FacebookLoginResponse) => {
    //   let params = new Array<string>();
    //   this.fb.api("/me?fields=name,email", params)
    //     .then(res => {
    //       this.userProvider.hasFacebookByKey(res.id).subscribe(async data => {
    //         if (!data) {
    //           let usuario: any = {};
    //           usuario.nome = res.name;
    //           usuario.email = res.email;
    //           usuario.id = res.id;
    //           usuario.foto = 'https://graph.facebook.com/' + res.id + '/picture?type=normal'
    //           usuario.token = response.authResponse.accessToken;

    //           this.facebook = usuario;
    //           // this.events.publish('user:facebook', this.facebook);
    //         } else {
    //           const alert = await this.alertCtrl.create({
    //             header: this.translate.instant('Erro'),
    //             subHeader: this.translate.instant('Essa conta do facebook já está vinculada a outro usuário'),
    //             buttons: ['OK']
    //           });
    //           alert.present();
    //         }
    //       });

    //     }, (error) => {
    //       console.log('ERROR: ', error);
    //     })
    // }, (error) => {
    //   console.log('ERROR: ', error);
    // });
  }

  async goToForgotPassword() {
    let data = { modal: true };
    const modal = await this.modalCtrl.create({ component: RecuperarSenhaPage, componentProps: data });
    modal.present();
  }
}
